import {
  Typography,
  TextField,
  // Checkbox,
  Box,
  Radio,
  Select,
  MenuItem,
  InputLabel,
  FormHelperText,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Button,
  // Slider,
  FormLabel,
  Grid,
  TextareaAutosize
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { useForm, Controller } from 'react-hook-form';
import React from 'react';
import _ from 'lodash';
import { MuiPickersUtilsProvider, DateTimePicker } from '@material-ui/pickers';
import { CustomDateFnsUtils, LuiDateRangePicker } from '@jda/lui-common-component-library';

const useStyles = makeStyles(theme => ({
  buttonMargin: {
    marginRight: theme.spacing(2),
    float: 'right',
    marginTop: theme.spacing(0.5)
  },
  formControlLabel: {
    '& > *': {
      fontWeight: 400,
      fontSize: '0.875rem'
    }
  },
  radioGroup: {
    display: 'inline-block'
  },
  textFieldStyle: {
    width: '100%'
  },
  formControl: {
    width: '80%'
  },
  label: {
    margin: '20px 0px 0px 0px'
  },
  textArea: {
    margin: '10px 0',
    fontFamily: 'inherit',
    fontSize: '0.875rem',
    lineHeight: '1.3rem'
  }
}));

interface FormsMetaDataType {
  key: string;
  label: string;
  defaultValue?: any;
  type: string;
  rules?: object;
  values?: Array<any> | any;
  labelStyleType?: 'Typography' | 'InputLabel' | any;
  size?: 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12 | 'auto';
  required?: true | false;
  disabled?: true | false;
  format?: string;
  hide?: true | false;
  displayName?: string;
  multiple?: true | false;
}

export const Form = (formProps: any) => {
  const classes = useStyles();
  const { handleSubmit, getValues, control, errors } = useForm();

  // const handleCheck = (key: any, checkedId: any) => {
  //   const formValues = getValues();
  //   const ids = formValues[key] || [];
  //   const newIds = ids?.includes(checkedId) ? ids?.filter((id: any) => id !== checkedId) : [...(ids ?? []), checkedId];
  //   return newIds;
  // };

  const renderTextField = (props: FormsMetaDataType) => {
    return (
      !props?.hide && (
        <Controller
          inputProps={{ 'aria-label': props.label }}
          // fullWidth
          id={props.key}
          as={TextField}
          className={classes.textFieldStyle}
          type={props.type}
          name={props.key}
          required={props.required}
          label={props.label}
          defaultValue={props.defaultValue}
          control={control}
          rules={props.rules}
          error={(errors && errors[props.key]?.message) || false}
          disabled={props.disabled}
        />
      )
    );
  };

  const handleChange = (e: any, key: string) => {
    if (typeof formProps?.getLatestValues === 'function') {
      const values = getValues();
      if (e?.target?.value) values[key] = e.target.value;
      formProps?.getLatestValues(values);
    }
  };

  const renderDropDown = (props: FormsMetaDataType) => {
    return (
      <Controller
        as={
          <Select
            multiple={props.multiple}
            label={props.label}
            disabled={props.disabled}
            value={props.defaultValue}
            onClick={e => handleChange(e, props.key)}
          >
            {props.values?.map((item: any) => [<MenuItem value={item.value}>{item.label}</MenuItem>])}
          </Select>
        }
        defaultValue={props.defaultValue}
        name={props.key}
        rules={props.rules}
        error={(errors && errors[props.key]?.message) || false}
        control={control}
      />
    );
  };

  // const renderCheckbox = (props: FormsMetaDataType) => {
  //   return (
  //     <Controller
  //       name={props.key}
  //       rules={props.rules}
  //       defaultValue={props.defaultValue}
  //       render={subProps =>
  //         props.values?.map((item: any, index: number) => (
  //           <FormControlLabel
  //             control={
  //               <Checkbox
  //                 color="primary"
  //                 onChange={() => subProps.onChange(handleCheck(props.key, item.value))}
  //                 defaultChecked={props.defaultValue.includes(item.value)}
  //               />
  //             }
  //             key={item.value}
  //             label={item.label}
  //             // className={classes.formControlLabel}
  //           />
  //         ))
  //       }
  //       control={control}
  //     />
  //   );
  // };

  const renderRadioButtons = (props: FormsMetaDataType) => {
    return (
      <Controller
        defaultValue={props.defaultValue}
        as={
          <div style={{ width: '100%' }}>
            <Box display="inline">
              <FormLabel>{props?.label}</FormLabel>
            </Box>
            <Box m={2} display="inline">
              <RadioGroup
                row
                className={classes.radioGroup}
                defaultValue={props.defaultValue}
                onClick={e => handleChange(e, props.key)}
              >
                {props?.values?.map((item: any) => {
                  return (
                    <FormControlLabel
                      value={item.value}
                      labelPlacement="end"
                      control={<Radio color="primary" />}
                      label={item.label}
                      className={classes.formControlLabel}
                    />
                  );
                })}
              </RadioGroup>
            </Box>
          </div>
        }
        rules={props.rules}
        name={props.key}
        control={control}
      />
    );
  };

  // const renderSlider = (props: any) => {
  //   return (
  //     <Controller
  //       defaultValue={props.defaultValue}
  //       render={subProps => (
  //         <Slider
  //           {...subProps}
  //           onChange={(_, value) => {
  //             subProps.onChange(value);
  //           }}
  //           valueLabelDisplay="auto"
  //           max={props.values.max}
  //           step={props.values.step}
  //         />
  //       )}
  //       name={props.key}
  //       rules={props.rules}
  //       error={(errors && errors[props.key]?.message) || false}
  //       control={control}
  //     />
  //   );
  // };

  // const renderDateRangePicker = (props: FormsMetaDataType) => {
  //   return (
  //     <Controller
  //       defaultValue={props.defaultValue}
  //       render={subProps => (
  //         <MuiPickersUtilsProvider utils={CustomDateFnsUtils}>
  //           <LuiDateRangePicker
  //             value={props.defaultValue}
  //             autoOk
  //             disableToolbar
  //             onChange={(value: any) => {
  //               subProps.onChange(value);
  //             }}
  //             variant="inline"
  //           />
  //         </MuiPickersUtilsProvider>
  //       )}
  //       name={props.key}
  //       rules={props.rules}
  //       error={(errors && errors[props.key]?.message) || false}
  //       control={control}
  //     />
  //   );
  // };

  const renderDateTimePicker = (props: FormsMetaDataType) => {
    return (
      <Controller
        defaultValue={props.defaultValue}
        render={subProps => (
          <MuiPickersUtilsProvider utils={CustomDateFnsUtils}>
            <DateTimePicker
              format={props.format}
              disableToolbar
              label={props.label}
              variant="dialog"
              key={props.key}
              value={props.defaultValue}
              onChange={(value: any) => {
                formProps.setDate(value, props.key);
                subProps.onChange(value);
              }}
              animateYearScrolling={false}
              inputProps={{ 'aria-label': 'date picker' }}
            />
          </MuiPickersUtilsProvider>
        )}
        name={props.key}
        rules={props.rules}
        error={(errors && errors[props.key]?.message) || false}
        control={control}
      />
    );
  };

  const renderTextArea = (props: FormsMetaDataType) => {
    return (
      <Controller
        as={
          <TextareaAutosize
            className={classes.textArea}
            disabled={props.disabled}
            value={props.defaultValue}
            rowsMin={5}
            name={props.key}
            key={props.key}
            onChange={e => handleChange(e, props.key)}
          />
        }
        defaultValue={props.defaultValue}
        name={props.key}
        key={props.key}
        rules={props.rules}
        error={(errors && errors[props.key]?.message) || false}
        control={control}
      />
    );
  };

  const renderFormType = (props: FormsMetaDataType, data: any) => {
    const fieldType = props.type;
    // if (data !== undefined && data[props.key] !== null) props.defaultValue = data[props.key];
    switch (fieldType) {
      case 'radio':
        return renderRadioButtons(props);
      // case 'checkbox':
      //   return renderCheckbox(props);
      case 'dropdown':
        return renderDropDown(props);
      // case 'slider':
      //   return renderSlider(props);
      case 'date':
        return renderDateTimePicker(props);
      case 'boolean':
        return renderRadioButtons(props);
      case 'textarea':
        return renderTextArea(props);
      case 'number':
      default:
        return renderTextField(props);
    }
  };

  const renderTypographyLabel = (props: FormsMetaDataType) => {
    return (
      <Typography
        variant="inherit"
        color="textPrimary"
        // className={classes.labelMargin}
      >
        {props.label}
      </Typography>
    );
  };

  const renderInputLabel = (props: FormsMetaDataType) => {
    return (
      <InputLabel error={(errors && errors[props.key]?.message) || false} shrink id={props.key}>
        {props.label}
      </InputLabel>
    );
  };

  const renderLabel = (props: any) => {
    const labelType = props?.labelStyleType || undefined;
    if (labelType) {
      return labelType === 'InputLabel' ? renderInputLabel(props) : renderTypographyLabel(props);
    }
    return '';
  };

  const renderErrorMessages = (props: FormsMetaDataType) => {
    return <FormHelperText error>{errors[props.key]?.message}</FormHelperText>;
  };

  return (
    <div>
      <Box m={3}>
        <Grid container item xs={12} spacing={1}>
          {Object.keys(_.groupBy(formProps?.dataConfig, 'group')).map((item: any) => (
            <div
              style={{ backgroundColor: '#fff', width: '100%', margin: '10px 0', padding: '10px', borderRadius: '5px' }}
            >
              {item !== 'undefined' && (
                <Typography
                  noWrap
                  color="initial"
                  variant="h3"
                  className={classes.label}
                  id={item}
                  style={{ backgroundColor: '#fff' }}
                >
                  {item}
                </Typography>
              )}
              <Grid
                container
                item
                xs={12}
                style={{
                  margin: '10px 0',
                  padding: '0 0 15px 0',
                  borderBottom: '1px solid #ececec',
                  backgroundColor: '#fff'
                }}
              >
                {_.groupBy(formProps?.dataConfig, 'group')[item].map((item: FormsMetaDataType) => (
                  <Grid key={item?.key} item xs={item.size} style={{ margin: '10px 0' }}>
                    <FormControl key={item?.key} className={classes.formControl}>
                      {renderLabel(item)}
                      {renderFormType(item, formProps.data)}
                      {errors && errors[item.key]?.message && renderErrorMessages(item)}
                    </FormControl>
                  </Grid>
                ))}
              </Grid>
            </div>
          ))}

          <Grid item xs={10}>
            {formProps.children}
          </Grid>
          {formProps.submitlabel && formProps.dataConfig?.length > 0 && (
            <Button
              className={classes.buttonMargin}
              data-id="handle-submit"
              onClick={handleSubmit(data => formProps.handleDialogSubmit(data))}
              type="submit"
              variant="contained"
              color="primary"
              disableElevation
              disabled={formProps.disabled}
            >
              {formProps.submitlabel}
            </Button>
          )}
        </Grid>
      </Box>
    </div>
  );
};
